import { useState, useEffect } from 'react';
import './ThankYou.scss';
import { Puff } from 'react-loader-spinner';
import ThankYouImg from '../../../assets/images/thanks.webp';

export default function ThankYou(props) {
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoader(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, [props]);

    return (
        <div className="thank-you-container">
            {showLoader ? (
                <div className="loader">
                <Puff
                    color="#4583A1"
                    height={135}
                    width={135}
                    visible={showLoader}
                />
            </div>
            ) : (
            
                <img src={ThankYouImg} alt="Thank You" className='thank-you-img' />
            )}
        </div>
    );
}

